var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
let ArticleNameElement = class ArticleNameElement extends Vue {
    constructor() {
        super(...arguments);
        this.name = "";
    }
    nameChanged(e) { return e; }
    get invalid() { return this.name === ""; }
    get elementKey() { return "articleName"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    created() { this.name = this.value; }
    onValueChanged(val, _oldVal) { this.name = val; }
};
__decorate([
    Prop({ required: true })
], ArticleNameElement.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], ArticleNameElement.prototype, "value", void 0);
__decorate([
    Inject()
], ArticleNameElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], ArticleNameElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], ArticleNameElement.prototype, "nameChanged", null);
__decorate([
    Watch("value")
], ArticleNameElement.prototype, "onValueChanged", null);
ArticleNameElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "ArticleNameElement",
    })
], ArticleNameElement);
export default ArticleNameElement;
